import { render, staticRenderFns } from "./headCard.vue?vue&type=template&id=3cd97e52&"
import script from "./headCard.vue?vue&type=script&lang=js&"
export * from "./headCard.vue?vue&type=script&lang=js&"
import style0 from "./headCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports